import Button from "./Button";
import * as React from "react";
import Box from "@mui/material/Box";
import constants from "../constants";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import SQLPage from "./Student/SQLPage/SQLPage";
import Typography from "@mui/material/Typography";
import AlertContext from "../context/AlertContext";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import { LibraryContext } from "../context/LibraryContext";
import Description from "./Admin/QuestionEntry/Description";
import useCommonFunctionHooks from "../Hooks/useCommonFunctionHooks";
import CodingQuestionEntryHooks from "./Admin/QuestionEntry/CodingQuestionEntry/Hooks/CodingQuestionEntryHooks";

const steps = ["Description", "Preview"];

export default function HorizontalLinearStepper() {
  const Alert = React.useContext(AlertContext);
  const LibraryCxt = React.useContext(LibraryContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const CodingQuestionEntryHks = CodingQuestionEntryHooks();

  const handleNext = () => {
    LibraryCxt.userInput["topicData"] = LibraryCxt.topicAndComplexity;

    let mandatoryFields = [];

    if (
      LibraryCxt.userInput.name === "" ||
      LibraryCxt.userInput.name === null ||
      LibraryCxt.userInput.name === undefined
    ) {
      mandatoryFields.push("Name");
    }

    if (LibraryCxt.topicAndComplexity.length < 1) {
      mandatoryFields.push("Topic");
    }

    if (mandatoryFields.length > 0) {
      return Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: `Missing ${mandatoryFields.join(",")}`,
      });
    }

    LibraryCxt.setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    LibraryCxt.setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    LibraryCxt.setActiveStep(0);
  };

  const handleNavigate = () => {
    useCommonFunctionHks.handleClose();
      Alert.setTestDetail({}); 
    Alert.navigate(`/library/${Alert.tableShowStatus}/questionlist`);
  };

  const handleSave = () => {
    let form = new FormData();
    let requestMethod = !Alert.isqueReport ? axios.post : axios.put;

    let url = !Alert.isqueReport
      ? "node/admin/library/sql"
      : `node/admin/library/sql/${Alert.testDetail.qnId}`;

    form.append("name", Alert.testDetail.name);
    form.append("solution", Alert.testDetail.solution);
    form.append("dbSchema", Alert.testDetail.dbSchema);
    form.append("ans_explain", Alert.testDetail.ansexp);
    form.append("description", Alert.testDetail.description);
    form.append("topics", JSON.stringify(LibraryCxt.topicAndComplexity));

    requestMethod(
      url,
      form,
      useCommonFunctionHks.getHeaderDetailsForAxios("multipart")
    )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.msg,
            primaryButtonFunction: handleNavigate,
          });
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg,
          });
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  };

  return (
    <div className="wizardMainContainer">
      <div className="wizardHeader">
        <span className="wizardTestName">Create SQL Question</span>
        <Stepper activeStep={LibraryCxt.activeStep} alternativeLabel>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};

            return (
              <Step key={index} {...stepProps} className="wizardStepper">
                <StepLabel {...labelProps} className="wizardStepperLabel">
                  {label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div className="wizardHeaderBtn">
          <Button
            size="sm"
            onClick={
              LibraryCxt.activeStep === 0
                ? CodingQuestionEntryHks.handleBackFromQuestion
                : handleBack
            }
            disabled={LibraryCxt.activeStep === 0}
            hierarchy={{ type: "secondaryGrey", buttonText: "Back" }}
          />
          <Button
            size="sm"
            onClick={LibraryCxt.activeStep === 1 ? handleSave : handleNext}
            disable={
              LibraryCxt.activeStep === 1 &&
              !Alert.testDetail.hasOwnProperty("output")
            }
            hierarchy={{
              type: "primary",
              buttonText:
                LibraryCxt.activeStep === steps.length - 1
                  ? Alert.isqueReport
                    ? "Update"
                    : "Save"
                  : "Next",
            }}
          />
        </div>
      </div>
      {LibraryCxt.activeStep === steps.length ? (
        <>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button
              size="sm"
              onClick={handleReset}
              hierarchy={{
                type: "primary",
                buttonText: "Reset",
              }}
            />
          </Box>
        </>
      ) : (
        <>
          {LibraryCxt.activeStep + 1 === 1 ? (
            <Description />
          ) : LibraryCxt.activeStep + 1 === 2 ? (
            <SQLPage />
          ) : (
            <Typography sx={{ mt: 2, mb: 1 }}>
              Step {LibraryCxt.activeStep + 1}
            </Typography>
          )}
        </>
      )}
    </div>
  );
}
